import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { Pane, Dialog } from 'evergreen-ui';
import axios from "axios";
import Select from "react-select";
import Host from "../../../assets/js/Host";
import { toast } from 'react-toastify';
const cookies = new Cookies();
const token = cookies.get("token")
const language = cookies.get("language") ? cookies.get("language") : "ar"

export const UserForm = (props) => {
    const [loading, setloading] = useState(true);
    const [departments, setdepartments] = useState([]);
    const [object, setobject] = useState({
        id: null,
        full_name: null,
        phone: null,
        username: null,
        password:null,
        department_id: null,
        department:{
            id:null,
            name:null
        }
    });
    const getResources = async () => {
        try {
            setloading(true)
            const resourcesResult = await axios({
                url: Host + "departments",
                method: "get",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    Accept: "application/json",
                    'X-localization': language,
                }
            })
            if (resourcesResult) {
                if (resourcesResult.status === 200) {
                    const resources = resourcesResult.data.data;
                    
                    setdepartments(resources.map((resource)=>{
                        return {
                            value:resource.id,
                            label:resource.name
                        }
                        
                    }));
                    if(props&& props.user&& props.user.id>0)
                    {
                        setobject({...object,...props.user});
                    }
                    else{
                        console.log("hi");
                        setobject(
                            {
                                id: null,
                                full_name: null,
                                phone: null,
                                username: null,
                                password:null,
                                department_id: null,
                                department:{
                                    id:null,
                                    name:null,
                                }
                            }
                        )
                    }
                } else if (resourcesResult.data.status === false) {

                }
            }
            else {
                toast.error("Error")
            }
            setloading(false)
        } catch (error) {
            setloading(false)            
            toast.error("Network Error")
        }
    };

    const submitForm = async () => {
        
        try {
            
        
            if (object.id) {
                const resourcesResult = await axios({
                    url: Host + "users/"+object.id,
                    method: "put",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        Accept: "application/json",
                        'X-localization': language,
                    },
                    data: object
                })
                if (resourcesResult) {
                    if (resourcesResult.status === 200) {
                        toast.success("updated ")
                        props.setshowUserForm(false,true)
                    } else if (resourcesResult.data.status === false) {
                        props.setshowUserForm(true,false)
                    }
                }
                else {
                    toast.error("Error")
                    props.setshowUserForm(true,false)
                }
                setloading(false)
            }
            else {
                const resourcesResult = await axios({
                    url: Host + "register",
                    method: "post",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        Accept: "application/json",
                        'X-localization': language,
                    },
                    data: object
                })
                if (resourcesResult) {
                    if (resourcesResult.status === 200) {
                        toast.success("saved ")
                        props.setshowUserForm(false,true)
                    } else if (resourcesResult.status === 400) {
                        toast.error(resourcesResult.data)
                        props.setshowUserForm(true,false)
                    }
                }
                else {
                    toast.error("Error")
                    props.setshowUserForm(true,false)
                }
                setloading(false)
            }
        } catch (error) {
            props.setshowUserForm(true,false)
            const resourcesResult=error.response            
            if (resourcesResult && resourcesResult.status === 400) {
                if(typeof resourcesResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(resourcesResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        resourcesResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    
                    toast.error(resourcesResult.data.data)
                }
                
                
            }
            else if(resourcesResult && resourcesResult.status === 401) {
             
                toast.error(resourcesResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
              
                toast.error("network error")
            }
        }
        
    };


    useEffect(() => {        
        console.log(props);
        
        if(loading)
        getResources()

        
        return () => {

        };
    }, [loading,props.showUserForm]);


    return (
        loading ? <></> :
        <Dialog
                isShown={props.showUserForm}
                onCloseComplete={() => props.setshowUserForm(false)}
                hasHeader={false}
                shouldCloseOnOverlayClick={false}
                confirmLabel="Save"
                cancelLabel="Cancel"
                onConfirm={() => {submitForm()}}
                >
            {object &&  object.id>0?
            <h4>Update user</h4>:
            <h4>Create user</h4>}
            <form >
                <div className="form-group">
                    <label htmlFor="full_name">Full Name</label>
                    <input className="form-control" 
                        id="full_name"
                        value={object.full_name}
                        onChange={event => { setobject({ ...object, full_name: event.target.value }); }}
                     />
                </div>
                <div className="form-group">
                    <label htmlFor="phone">Phone</label>
                    <input
                        type="phone"
                        className="form-control"
                        id="phone"
                        value={object.phone}
                        placeholder="+9647xxxxxxxxx"
                        onChange={event => {console.log(event.target.value); setobject({ ...object, phone: event.target.value }); }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                        type="username"
                        className="form-control"
                        id="username"
                        value={object.username}
                        placeholder="username"
                        onChange={event => { setobject({ ...object, username: event.target.value }); }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="department">department</label>
                    <Select onChange={e => {console.log(e); setobject({ ...object, department:{
                        name:e.label,
                        id:e.value
                    }, department_id: e.value }); }}
                        defaultValue={{value:object?.department?.id,label:object?.department?.name}}
                        value={{value:object?.department?.id,label:object?.department?.name}}
                        styles={customStyles}
                        options={departments}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">password</label>
                    <input
                        type="password"
                        className="form-control"
                        id="password"
                        value={object.password}
                        placeholder="password"
                        onChange={event => { setobject({ ...object, password: event.target.value }); }}
                    />
                </div>
                
                
            </form>
        </Dialog>

    );
};
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: '1px dotted pink',
        color: state.isSelected ? 'red' : 'blue',

    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        width: '100%',
        border: '1px solid #ababab',
        borderRadius: 5,
        padding: 0,
        display: 'flex'
    }),
    container: () => ({

        width: '80%',
        position: 'relative',
        boxSizing: 'border-box',
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        return { ...provided, opacity, transition };
    }
}

export default UserForm;
